import i18nConfig from "@/i18n-config";
import { createInstance } from "i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next/initReactI18next";

export default async function initTranslations(locale, i18nInstance, resources) {
    i18nInstance = i18nInstance || createInstance();

    i18nInstance.use(initReactI18next);

    if (!resources) {
        i18nInstance.use(resourcesToBackend((language) => import(`../locales/${language}.json`)));
    }

    await i18nInstance.init({
        lng: locale,
        resources,
        fallbackLng: i18nConfig.defaultLocale,
        supportedLngs: i18nConfig.locales,
        ns: ["translation"],
        defaultNS: "translation",
        fallbackNS: "translation",
        preload: resources ? [] : i18nConfig.locales,
    });

    return {
        i18n: i18nInstance,
        resources: { [locale]: i18nInstance.services.resourceStore.data[locale] },
        t: i18nInstance.t,
    };
}
